import React from 'react'
import PropTypes from 'prop-types'

export default function HealthIcon(props) {

    const onClick = ()=>{if (props.onClick) props.onClick(props.value)}

    const value = typeof props.value === 'string' ? parseInt(props.value) : props.value

    let type = 'not-set'
    switch (value) {
        case 0: type = 'low'; break
        case 1: type = 'medium'; break
        case 2: type = 'high'; break
    }

    return <div className={Classes("gd-health-icon", type+"-type", "s{0}".f(props.size), props.className)} onClick={onClick}/>
}

HealthIcon.propTypes = {
    value   : PropTypes.any, //string or number
    size    : PropTypes.oneOf(['14','20']),
    onClick : PropTypes.func
}

HealthIcon.defaultProps = {
    size    : '20',
}